module.exports = __webpack_public_path__ + "static/assets/f24b98712fda6ab706542aa88a18a874.png";